var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureMovedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8374 4.28578L7.98011 1.42851H1.429V18.5716H24.2869V4.2859L10.8374 4.28578ZM0.000489534 1.42851C0.000489534 0.639499 0.639989 0 1.429 0H7.98011C8.35895 0 8.72223 0.150431 8.99033 0.418292L11.4291 2.85702H24.2864C25.0754 2.85702 25.7149 3.49676 25.7149 4.28578V18.5715C25.7149 19.3605 25.0754 20 24.2864 20H1.42851C0.639499 20 0 19.3605 0 18.5715L0.000489534 1.42851Z",
    fill: "#F2994A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7035 10.7107L13.0655 9.07272L14.0757 8.0625L17.4378 11.4249L14.0757 14.7873L13.0655 13.777L14.7033 12.1393H8.57031V10.7107H14.7035Z",
    fill: "#F2994A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureMovedIcon);
export default __webpack_public_path__ + "static/media/FeatureMovedIcon.1e8c75f694e1822dbd4a515cabf2d7d8.svg";
export { ForwardRef as ReactComponent };